import React, { Component } from 'react';
import { send, init } from 'emailjs-com';

class ContactForm extends Component {
	state = {
		name: '',
		email: '',
		message: '',
		formEmailSent: false,
		loading: false
	};

	componentDidMount() {
		init(process.env.REACT_APP_EMAILJS_USERID);
	}

	onChange = (e) => {
		this.setState({ [e.target.name]: e.target.value });
	};

	onSubmit = (e) => {
		e.preventDefault();
		const { name, email, message } = this.state;
		if (email.trim === '' || message.trim() === '') return false;
		this.setState({ loading: true });
		const { REACT_APP_EMAILJS_RECEIVER: receiverEmail, REACT_APP_EMAILJS_TEMPLATEID: template } = process.env;
		this.sendMail(template, name.trim(), email.trim(), receiverEmail, message.trim());
	};

	sendMail(templateId, name, email, receiverEmail, message) {
		send('mailjet', templateId, {
			name,
			email,
			receiverEmail,
			message
		})
			.then((res) => {
				this.setState({ formEmailSent: true, loading: false });
			})
			.catch((err) => console.error('Failed to send message. Error: ', err));
	}

	closeHandler = (e) => {
		if (e.target.name === 'modal' || e.target.name === 'close' || e.target.id === 'contact-modal') {
			this.setState({
				name: '',
				email: '',
				message: '',
				formEmailSent: false,
				loading: false
			});
			this.props.handleClose(e);
		}
	};

	render() {
		const { show } = this.props;
		const showHideClassName = show ? 'modal display-block' : 'modal display-none';
		const modalMainClass = show ? 'modal-main active' : 'modal-main';
		const sendButton = this.state.formEmailSent ? (
			<button className="contact__submit" type="submit" disabled style={{ color: 'green', fontSize: '1.5rem' }}>
				✔
			</button>
		) : (
			<button className="contact__submit" type="submit">
				{this.state.loading ? <span id="loading" /> : 'Submit'}
			</button>
		);
		return (
			<div className={showHideClassName} id="contact-modal" onClick={this.closeHandler} name="modal">
				<section className={modalMainClass} onClick={() => 1 + 2}>
					<p style={{ textAlign: 'center', paddingBottom: '15px', color: 'black' }}>
						You can send an email to <strong style={{ fontWeight: 'bold' }}>barisozcetin@gmail.com </strong>or contact
						with form below
					</p>
					<form method="POST" onSubmit={this.onSubmit} className="contact__form" style={{ marginTop: '5px' }}>
						<input type="text" name="name" placeholder="Your name" value={this.state.name} onChange={this.onChange} />
						<input
							type="email"
							name="email"
							placeholder="Your email"
							required
							value={this.state.email}
							onChange={this.onChange}
						/>
						<textarea
							name="message"
							placeholder="Your message"
							required
							value={this.state.message}
							onChange={this.onChange}
							rows={5}
						/>
						{sendButton}
					</form>
					<button
						name="close"
						className="modal__close"
						style={{ '--text-color': '#ffffff' }}
						onClick={this.closeHandler}
					>
						✖
					</button>
				</section>
			</div>
		);
	}
}

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/contact/ContactForm.js